module.exports = __webpack_public_path__ + "static/img/101680.2fc68c25.png";